<div class="title-container">
    <div class="chart-title">{{chartTitle | translate}}</div>
    <ng-container *ngIf="selectedPoint?.y !== null && selectedPoint?.x !== null; else showTotal">
        <div class="point-description-y">{{selectedPoint.y}}</div>
        <div class="point-description-x">{{selectedPoint.x}}</div>
    </ng-container>
    <ng-template #showTotal>
        <div *ngIf="displayTotal" class="point-description-y">{{total}}</div>
    </ng-template>

</div>
<div class="canvas-container">
    <canvas [id]="chartId" class="canvas" (mouseout)="canvasMouseOut()"></canvas>
</div>
<div class="abscissa-container">
    <div class="first-x" *ngIf="xValues.length > 0">{{xValues[0]}}</div>
    <div class="last-x" *ngIf="xValues.length > 0">{{xValues[xValues.length - 1]}}</div>
</div>
<ng-template #notReady>
    <div class="container-loading">
        <div class="loading-spinner-grey"></div>
    </div>
</ng-template>